module.exports = __webpack_public_path__ + "img/method-order-massal.6959ed17.svg";